export function unicodeSafeEncode(str: string): string {
  const codes: number[] = [];
  for (let i = 0; i < str.length; i++) {
    const code = str.codePointAt(i);
    if (code) {
      codes.push(code);
    }       
  }

  const codesString = codes.map((c) => { return c.toString(); }).join('-');
  const encoded = `ver:2${btoa(codesString)}`;
  return encoded;
}

export function unicodeSafeDecode(str: string): string | undefined {
  if (!(str.startsWith('ver:2') && str.length >  5)) {
    return;
  }

  return unicodeSafeDecodeV2(str.substring(5));
}

function unicodeSafeDecodeV2(str: string): string {
  const codesString = atob(str);
  const codes: number[] = codesString.split('-').map((s) => { return parseInt(s); });
  let orig = '';
  for (const c of codes) {
    orig += String.fromCodePoint(c);
  }

  return orig;
}